import React from "react";
import './ChatEditorLexical.scss';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {AutoFocusPlugin} from '@lexical/react/LexicalAutoFocusPlugin';
// import {AutoLinkPlugin} from '@lexical/react/LexicalAutoLinkPlugin';
import {ClearEditorPlugin} from '@lexical/react/LexicalClearEditorPlugin';
// import {AutoLinkNode} from "@lexical/link";
import {PlainTextPlugin} from '@lexical/react/LexicalPlainTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import MentionsPlugin from "../../../../../libs/lexical/plugins/mention/MentionsPlugin";
import { MentionNode } from "../../../../../libs/lexical/plugins/mention/MentionNode";
import NativeEmojiPlugin from "../../../../../libs/lexical/plugins/native-emoji/NativeEmojiPlugin";
import {HistoryPlugin} from "@lexical/react/LexicalHistoryPlugin";
import OnSubmit from "../../../../../libs/lexical/plugins/OnSubmit";
import convertToNext from "../../../../../libs/lexical/convertissors/simple";
import Icon from "../../../../components/Icon";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {CLEAR_EDITOR_COMMAND} from "lexical";

// const URL_MATCHER =
//     /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
//
// const MATCHERS = [
//     (text) => {
//         const match = URL_MATCHER.exec(text);
//         if (match === null) {
//             return null;
//         }
//         const fullMatch = match[0];
//         return {
//             index: match.index,
//             length: fullMatch.length,
//             text: fullMatch,
//             url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`,
//             // attributes: { rel: 'noopener', target: '_blank' }, // Optional link attributes
//         };
//     },
// ];

const initialConfig = {
    namespace: 'MyEditor',
    // theme,
    onError,
    nodes: [
        MentionNode
        // , AutoLinkNode
    ]
};

function onError(error) {
    console.error(error);
}

function SubmitButton({onSubmit = ()=>{}, autoClear = false}) {
    const [editor] = useLexicalComposerContext();
    function handleClick(){
        if (autoClear) editor.dispatchCommand(CLEAR_EDITOR_COMMAND);
        onSubmit(editor.getEditorState());
    }
    return (
        <div className={"icon-input"} onClick={handleClick}>
            <Icon type={"paper-plane"} className="icon-attach"/>
        </div>
    );
}


const ChatEditorLexical = ({mentions = [], onSubmit = ()=>{}})=>{
    function _onSubmit(editorState){
        let contentState = convertToNext(editorState);
        if (!!contentState.text) onSubmit(contentState);
    }
    return (
        <LexicalComposer initialConfig={initialConfig}>
            <div className="editor-container">
                <PlainTextPlugin
                    contentEditable={<ContentEditable className="editor-input"/>}
                    placeholder={<div className="editor-placeholder">Message</div>}
                    ErrorBoundary={LexicalErrorBoundary}
                />
                <HistoryPlugin />
                <NativeEmojiPlugin/>
                <AutoFocusPlugin/>
                <ClearEditorPlugin/>
                {/*<AutoLinkPlugin matchers={MATCHERS}/>*/}
                <OnSubmit
                    onSubmit={(editorState)=>_onSubmit(editorState)}
                    autoClear={true}
                />
                <MentionsPlugin mentions={mentions}/>
            </div>
            <SubmitButton
                onSubmit={(editorState)=>_onSubmit(editorState)}
                autoClear={true}
            />
        </LexicalComposer>
    );
}

export default ChatEditorLexical;